<template>
    <div class="custom-wrapper">
        <div class="custom-container">
            <v-row no-gutters justify="center">
                <v-col cols="12" md="8">
                    <v-card flat>
                        <v-card-title>
                            <span class="headline">Profil</span>
                            <v-spacer/>
                        </v-card-title>
                    </v-card>
                    <v-form ref="detailsForm">
                        <v-card flat>
                            <v-card-title>
                                Details
                                <v-spacer/>
                                <v-btn small color="primary" outlined depressed v-if="readonly" @click="readonly = false">Bearbeiten</v-btn>
                                <v-btn small color="primary" depressed v-else @click="postDetails">Speichern</v-btn>
                            </v-card-title>
                            <v-card-text>
                                    <v-text-field
                                            label="E-Mail-Adresse"
                                            outlined
                                            v-model="details.email"
                                            :readonly="readonly"
                                    ></v-text-field>
                                    <v-text-field
                                            label="Vorname"
                                            outlined
                                            v-model="details.first_name"
                                            :readonly="readonly"
                                    ></v-text-field>
                                    <v-text-field
                                            label="Nachname"
                                            outlined
                                            v-model="details.last_name"
                                            :readonly="readonly"
                                    ></v-text-field>
                            </v-card-text>
                        </v-card>
                    </v-form>
                    <v-form ref="passwordForm">
                        <v-card flat>
                            <v-card-title>
                                Passwort
                                <v-spacer/>
                                <v-btn small color="primary" depressed :disabled="isDisabled" @click="postPassword">Speichern</v-btn>
                            </v-card-title>
                            <v-card-text>
                                <v-text-field
                                        type="password"
                                        clearable
                                        label="Altes Passwort"
                                        outlined
                                        v-model="password.old"
                                ></v-text-field>
                                <v-text-field
                                        type="password"
                                        clearable
                                        label="Neues Passwort"
                                        outlined
                                        v-model="password.new"
                                ></v-text-field>
                                <v-text-field
                                        type="password"
                                        clearable
                                        label="Neues Passwort bestätigen"
                                        outlined
                                        v-model="password.new_confirmation"
                                ></v-text-field>
                            </v-card-text>
                        </v-card>
                    </v-form>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';

    export default {
        props: [],
        name: "",
        data: () => ({
            readonly: true,
            details: {
                first_name: '',
                last_name: '',
                email: '',
            },
            password: {
                old: '',
                new: '',
                new_confirmation: ''
            }
        }),
        methods: {
            ...mapActions({
                patchMe: 'user/patchMe',
            }),
            postDetails(){
                this.patchMe(this.details).
                    then(() => {
                        this.$toast.success('Die Änderungen wurden erfolgreich gespeichert!');
                        this.readonly = true;
                })
                    .catch(() => {
                        this.$toast.error('Die Änderungen wurden nicht gespeichert.');
                });

            },
            postPassword(){
                this.patchMe({
                    'old_password' : this.password.old,
                    'password' : this.password.new,
                    'password_confirmation' : this.password.new_confirmation,
                }).
                then(() => {
                    this.$toast.success('Die Änderungen wurden erfolgreich gespeichert!');
                })
                    .catch(() => {
                        this.$toast.error('Die Änderungen wurden nicht gespeichert.');
                    });
                this.$refs.passwordForm.reset();
            },
        },
        mounted() {
            this.$store.dispatch('user/me').then((response) => {
                this.details = {...response.data};
            })
        },
        computed: {
            ...mapGetters({

            }),
            isDisabled(){
                return !(this.password.old && this.password.new && this.password.new_confirmation);
            }
        }
    }
</script>

<style scoped>

</style>